import SddSections from 'components/OrderConfirmation/SddSections/SddSections';
import withSddSectionsProps from 'viewModel/orderConfirmation/sddSections/withSddSectionsProps';

const ConnectedSddSections = withSddSectionsProps(SddSections);

export default ConnectedSddSections;
